<template>
  <div class="flex-grow flex flex-col">
    <top-sub-b class="relative">
      <navigation-government
        v-if="councillors.length"
        :title="$t('views.government.executive.group_title')"
        :numMembers="councillors.length"
      />
    </top-sub-b>
    <div class="relative flex flex-col" style="flex-grow: 1;">
      <content-scroll-container style="flex-grow: 1;">
        <content-scroll-inner class="pb-8">
          <div
            ref="scrollarea"
            class="h-full overflow-x-hidden -ml-4 px-4 -mr-4 pt-2 lg:ml-0 lg:mr-0 lg:px-0"
          >
            <person-slot-grid
              class="w-full"
              :people="councillors"
              :candidate-size="'small'"
              v-if="councillors.length > 0"
              :hasShadow="true"
              @clickedProfile="clickedProfile"
            ></person-slot-grid>
          </div>
        </content-scroll-inner>
      </content-scroll-container>
      <template v-if="isLoading">
        <div class="relative" style="height:50vh;">
          <icon-loading-spinner
            :fade="true"
            color="gray"
            class="absolute-center"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import NavigationGovernment from "@/components/nav/NavigationGovernment";
import ContentScrollInner from "@/components/layouts/ContentScrollInner";
import ContentScrollContainer from "@/components/layouts/ContentScrollContainer";
import TopSubB from "@/components/layouts/TopSubB";
import IconLoadingSpinner from "@/components/icons/IconLoadingSpinner";
import { LanguageCode } from "../../utils/LanguageCode";
import client from "api-client";
import PersonSlotGrid from "@/components/people/PersonSlotGrid";
import StatusBarDirective from "@/directives/StatusBarDirective";

export default {
  name: "Executive",
  directives: { statusbar: StatusBarDirective },
  components: {
    IconLoadingSpinner,
    TopSubB,
    ContentScrollContainer,
    ContentScrollInner,
    NavigationGovernment,
    PersonSlotGrid
  },
  data: () => ({
    councillors: [],
    isLoading: false
  }),
  async created() {
    this.isLoading = true;
    this.councillors = await client.fetchFederalCouncillors(
      LanguageCode.get(this.contentLanguage)
    );
    this.isLoading = false;
  },
  computed: {
    ...mapGetters("user", ["contentLanguage", "user"]),
    ...mapGetters("location", ["canton"]),
    background() {
      return this.canton(this.user.cantonId).backgroundGradient;
    }
  },
  methods: {
    clickedProfile({ personId }) {
      this.$router.push({
        name: "federal-councillor",
        params: { id: personId }
      });
    }
  }
};
</script>
